import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import useUserManagementStore from "../api/store";
import StyledDialogActions from "../../../common/components/dialog/dialog-actions";
import { commonButtonProps } from "../../../common/components/buttons/sxprops";
import { commonTextFieldProps } from "../../../common/components/textfield";
import { ModalTransition } from "../../../common/components/transitions";
import StyledDialogTitle from "../../../common/components/dialog/dialog-title";
import { Handlers } from "../api/handlers";
import { useLockUser } from "../api/hooks";
import { LoadingButton } from "@mui/lab";
interface LockUserModalProps {
  isInternal: boolean;
}

export const LockUserModal: React.FC<LockUserModalProps> = ({ isInternal }) => {
  const userManagementStore = useUserManagementStore();
  const { mutate: lockUser, status, isPending } = useLockUser(isInternal);
  const handlers = new Handlers();
  const [reason, setReason] = useState<string | undefined>();
  const isValid = reason && reason.trim() !== "";

  const handleSubmit = () => {
    lockUser(
      {
        userId: userManagementStore.selectedUserId ?? "",
        adminLockingReason: reason ?? "",
      },
      {
        onSuccess: () => {
          handlers.handleCloseLockUserModal();
        },
      },
    );
  };

  return (
    <Dialog
      maxWidth={"laptop"}
      fullWidth
      open={userManagementStore.isLockUserModalOpen}
      slots={{
        transition: ModalTransition,
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "24px",
          },
        },
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      {
        <>
          <StyledDialogTitle
            actionType={"close"}
            title="Lock User"
            handleClose={handlers.handleCloseLockUserModal}
          />

          <DialogContent sx={{ minWidth: "300px", mt: "28px" }}>
            <Box
              sx={{
                width: "100%",
              }}
            >
              <Typography
                color="#123257"
                sx={{
                  pb: "20px",
                }}
              >
                Input reason for locking account
              </Typography>
              <TextField
                id="lock-user-reason-input"
                multiline
                maxRows={3}
                fullWidth
                label="Input Reason here..."
                sx={commonTextFieldProps}
                onChange={(e) => {
                  setReason(e.target.value);
                }}
              />
            </Box>
          </DialogContent>

          <StyledDialogActions>
            <Button
              id="cancel-button"
              onClick={handlers.handleCloseLockUserModal}
              disabled={isPending}
            >
              Cancel
            </Button>
            <LoadingButton
              id="save-button"
              onClick={handleSubmit}
              loading={status === "pending"}
              loadingIndicator={
                <CircularProgress size={18} sx={{ color: "white" }} />
              }
              disabled={!isValid || isPending}
              sx={commonButtonProps}
            >
              {isPending ? (
                <CircularProgress size={18} sx={{ color: "inherit" }} />
              ) : (
                "Save"
              )}
            </LoadingButton>
          </StyledDialogActions>
        </>
      }
    </Dialog>
  );
};
